import axios from 'axios';
import {
  OptionType,
  OptionTypesResponse,
  ProductOptionsResponse,
  CreateOptionTypeRequest,
  UpdateOptionTypeRequest,
  AssignOptionToProductRequest,
} from '../types/optionTypes';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + '/api' || 'http://localhost:5000/api';

// Axios instance oluştur
const api = axios.create({
  baseURL: `${API_BASE_URL}/option-types`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const optionTypesService = {
  // Tüm seçenek türlerini getir
  async getAllOptionTypes(): Promise<OptionType[]> {
    try {
      const response = await api.get<OptionTypesResponse>('/');

      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Seçenek türleri getirilemedi');
      }
    } catch (error) {
      console.error('Option types getirme hatası:', error);
      throw error;
    }
  },

  // Belirli bir seçenek türünü getir
  async getOptionTypeById(id: number): Promise<OptionType> {
    try {
      const response = await api.get<{ success: boolean; data: OptionType; message?: string }>(
        `/${id}`
      );

      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Seçenek türü getirilemedi');
      }
    } catch (error) {
      console.error('Option type getirme hatası:', error);
      throw error;
    }
  },

  // Yeni seçenek türü oluştur
  async createOptionType(data: CreateOptionTypeRequest): Promise<OptionType> {
    try {
      const response = await api.post<{ success: boolean; data: OptionType; message?: string }>(
        '/',
        data
      );

      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Seçenek türü oluşturulamadı');
      }
    } catch (error: any) {
      console.error('Option type oluşturma hatası:', error);

      // Axios hatası ise response'dan mesajı al
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      }

      // Diğer hatalar için generic mesaj
      throw new Error(error.message || 'Seçenek türü oluşturulamadı');
    }
  },

  // Seçenek türünü güncelle
  async updateOptionType(id: number, data: UpdateOptionTypeRequest): Promise<OptionType> {
    try {
      const response = await api.put<{ success: boolean; data: OptionType; message?: string }>(
        `/${id}`,
        data
      );

      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Seçenek türü güncellenemedi');
      }
    } catch (error: any) {
      console.error('Option type güncelleme hatası:', error);

      // Axios hatası ise response'dan mesajı al
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      }

      throw new Error(error.message || 'Seçenek türü güncellenemedi');
    }
  },

  // Seçenek türünü sil
  async deleteOptionType(id: number): Promise<void> {
    try {
      const response = await api.delete<{ success: boolean; message?: string }>(`/${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Seçenek türü silinemedi');
      }
    } catch (error: any) {
      console.error('Option type silme hatası:', error);

      // Axios hatası ise response'dan mesajı al
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      }

      throw new Error(error.message || 'Seçenek türü silinemedi');
    }
  },

  // Ürün seçeneklerini getir
  async getProductOptions(productId: number): Promise<any[]> {
    try {
      const response = await api.get<ProductOptionsResponse>(`/product/${productId}`);

      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Ürün seçenekleri getirilemedi');
      }
    } catch (error) {
      console.error('Ürün seçenekleri getirme hatası:', error);
      throw error;
    }
  },

  // Ürüne seçenek ata
  async assignOptionToProduct(productId: number, data: AssignOptionToProductRequest): Promise<any> {
    try {
      const response = await api.post<{ success: boolean; data: any; message?: string }>(
        `/product/${productId}`,
        data
      );

      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Seçenek atanamadı');
      }
    } catch (error) {
      console.error('Seçenek atama hatası:', error);
      throw error;
    }
  },

  // Üründen seçenek kaldır
  async removeOptionFromProduct(productId: number, optionTypeId: number): Promise<void> {
    try {
      const response = await api.delete<{ success: boolean; message?: string }>(
        `/product/${productId}/${optionTypeId}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Seçenek kaldırılamadı');
      }
    } catch (error) {
      console.error('Seçenek kaldırma hatası:', error);
      throw error;
    }
  },
};
